import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
// No `toJSON()`: the `POST` this command drives carries no body — only the route identifies the interview.
class MarkTranscriptReviewed {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
	) {
		Object.freeze(this);
	}
}

export default MarkTranscriptReviewed;
